(function () {
  'use strict';

  // ── i18n (strings injected via window.casifyI18n in theme.liquid;
  //    Dutch fallbacks keep the page working if the object is missing) ──
  var I18N = window.casifyI18n || {};
  function t(key, fallback) {
    return (I18N[key] != null && I18N[key] !== '') ? I18N[key] : fallback;
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    var euros = cents / 100;
    return '€ ' + euros.toFixed(2).replace('.', ',');
  }

  // ── Gallery: one responsive image source + lightbox ──────────────────────────

  var mediaViewport = document.getElementById('product-media-viewport');
  var mediaTrack    = document.getElementById('product-media-track');
  var mediaSlides   = Array.prototype.slice.call(document.querySelectorAll('.product__media-slide[data-index]'));
  var mediaDots     = Array.prototype.slice.call(document.querySelectorAll('.product__media-dot'));
  var thumbBtns     = Array.prototype.slice.call(document.querySelectorAll('.product__thumb-btn'));
  var thumbsRow     = document.getElementById('product-thumbnails');
  var zoomTrigger   = document.getElementById('product-zoom-trigger');
  var mobileGalleryQuery = window.matchMedia('(max-width: 767px)');
  var galleryImages = mediaSlides.map(function (slide) { return slide.dataset.fullSrc; }).filter(Boolean);
  var currentIndex  = 0;

  function markCurrent(elements, index) {
    elements.forEach(function (element, elementIndex) {
      var active = elementIndex === index;
      element.classList.toggle('is-active', active);
      if (active) element.setAttribute('aria-current', 'true');
      else element.removeAttribute('aria-current');
    });
  }

  function keepThumbVisible(index) {
    if (!thumbsRow || !thumbBtns[index]) return;
    var thumb = thumbBtns[index];
    var rowRect = thumbsRow.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();
    if (thumbRect.left < rowRect.left || thumbRect.right > rowRect.right) {
      thumbsRow.scrollTo({
        left: thumb.offsetLeft - thumbsRow.clientWidth / 2 + thumb.clientWidth / 2,
        behavior: 'smooth'
      });
    }
  }

  function setActiveMedia(index, scrollOnMobile) {
    if (!mediaSlides.length) return;
    currentIndex = Math.max(0, Math.min(index, mediaSlides.length - 1));
    markCurrent(mediaSlides, currentIndex);
    markCurrent(mediaDots, currentIndex);
    markCurrent(thumbBtns, currentIndex);
    keepThumbVisible(currentIndex);

    if (scrollOnMobile && mobileGalleryQuery.matches && mediaSlides[currentIndex]) {
      mediaSlides[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  // ── Lightbox ──
  var lightbox        = document.getElementById('product-lightbox');
  // Re-parent the lightbox to <body> so its z-index applies at the root level.
  if (lightbox && lightbox.parentElement !== document.body) {
    document.body.appendChild(lightbox);
  }
  var lightboxImg     = document.getElementById('product-lightbox-img');
  var lightboxClose   = document.getElementById('product-lightbox-close');
  var lightboxPrev    = document.getElementById('product-lightbox-prev');
  var lightboxNext    = document.getElementById('product-lightbox-next');
  var lightboxCounter = document.getElementById('product-lightbox-counter');
  var lightboxReturnFocus = null;

  function openLightbox(index) {
    if (!lightbox || galleryImages.length === 0) return;
    currentIndex = index;
    lightboxImg.src = galleryImages[currentIndex];
    if (lightboxCounter) lightboxCounter.textContent = (currentIndex + 1) + ' / ' + galleryImages.length;
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.removeAttribute('inert');
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lightboxReturnFocus = document.activeElement;
    if (lightboxClose) lightboxClose.focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('inert', '');
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lightboxReturnFocus && lightboxReturnFocus.focus) lightboxReturnFocus.focus();
    lightboxReturnFocus = null;
  }
  function navLightbox(delta) {
    if (galleryImages.length < 2) return;
    currentIndex = (currentIndex + delta + galleryImages.length) % galleryImages.length;
    lightboxImg.src = galleryImages[currentIndex];
    if (lightboxCounter) lightboxCounter.textContent = (currentIndex + 1) + ' / ' + galleryImages.length;
  }

  mediaSlides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      var index = parseInt(this.dataset.index, 10) || 0;
      setActiveMedia(index, false);
      if (!mobileGalleryQuery.matches) openLightbox(index);
    });
  });

  thumbBtns.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setActiveMedia(parseInt(this.dataset.index, 10) || 0, true);
    });
  });

  mediaDots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      setActiveMedia(parseInt(this.dataset.index, 10) || 0, true);
    });
  });

  if (zoomTrigger) zoomTrigger.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(currentIndex); });
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev)  lightboxPrev.addEventListener('click', function () { navLightbox(-1); });
  if (lightboxNext)  lightboxNext.addEventListener('click', function () { navLightbox(1); });

  // Click outside image closes lightbox
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('product__lightbox-stage')) closeLightbox();
    });
  }
  // Keyboard navigation in lightbox
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  navLightbox(-1);
    if (e.key === 'ArrowRight') navLightbox(1);
    if (e.key === 'Tab') {
      var focusable = Array.prototype.slice.call(lightbox.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Native scroll-snap on mobile; desktop displays only the active slide.
  if (mediaTrack && mediaSlides.length > 0) {
    var galleryUpdateTimer = null;
    mediaTrack.addEventListener('scroll', function () {
      if (!mobileGalleryQuery.matches) return;
      if (galleryUpdateTimer) clearTimeout(galleryUpdateTimer);
      galleryUpdateTimer = setTimeout(function () {
        var slideWidth = mediaTrack.clientWidth;
        var index = slideWidth ? Math.round(mediaTrack.scrollLeft / slideWidth) : 0;
        setActiveMedia(index, false);
      }, 80);
    }, { passive: true });
  }

  function syncGalleryMode(event) {
    if (!mediaTrack || !mediaSlides.length) return;
    if (event.matches) {
      mediaTrack.scrollLeft = currentIndex * mediaTrack.clientWidth;
    } else {
      mediaTrack.scrollLeft = 0;
    }
    setActiveMedia(currentIndex, false);
  }

  if (mobileGalleryQuery.addEventListener) mobileGalleryQuery.addEventListener('change', syncGalleryMode);
  else mobileGalleryQuery.addListener(syncGalleryMode);

  // ── Quantity ─────────────────────────────────────────────────────────────────

  var qtyInput = document.querySelector('.product__qty-input');

  document.querySelectorAll('.product__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      if (this.dataset.action === 'plus')  val = Math.min(val + 1, 99);
      if (this.dataset.action === 'minus') val = Math.max(val - 1, 1);
      qtyInput.value = val;
    });
  });

  // ── Model dropdown — sort + navigate ─────────────────────────────────────────
  //
  //  Options are rendered in collection order by Liquid.
  //  JS re-orders them newest→oldest and wraps them in <optgroup> serie labels.
  //  For combined products (data-models="iPhone 13|iPhone 14") we use the
  //  earliest position in MODEL_ORDER (= the newest model in the combo).
  //

  var MODEL_ORDER = [
    // iPhone 18 serie
    'iPhone 18 Pro Max', 'iPhone 18 Pro',
    // iPhone 17 serie
    'iPhone Air', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 17e',
    // iPhone 16 serie
    'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e',
    // iPhone 15 serie
    'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
    // iPhone 14 serie
    'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
    // iPhone 13 serie
    'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13 Mini', 'iPhone 13',
    // iPhone 12 serie
    'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12 Mini', 'iPhone 12',
    // iPhone 11 serie
    'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
    // Overige iPhones
    'iPhone 8', 'iPhone SE 2022', 'iPhone SE 2020'
  ];

  var SERIE = t('series', 'serie');
  var MODEL_GROUPS = [
    { label: 'iPhone 18 ' + SERIE, models: ['iPhone 18 Pro Max', 'iPhone 18 Pro'] },
    { label: 'iPhone 17 ' + SERIE, models: ['iPhone Air', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 17e'] },
    { label: 'iPhone 16 ' + SERIE, models: ['iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e'] },
    { label: 'iPhone 15 ' + SERIE, models: ['iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15'] },
    { label: 'iPhone 14 ' + SERIE, models: ['iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14'] },
    { label: 'iPhone 13 ' + SERIE, models: ['iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13 Mini', 'iPhone 13'] },
    { label: 'iPhone 12 ' + SERIE, models: ['iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12 Mini', 'iPhone 12'] },
    { label: 'iPhone 11 ' + SERIE, models: ['iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11'] },
    { label: t('otherIphones', 'Overige iPhones'), models: ['iPhone 8', 'iPhone SE 2022', 'iPhone SE 2020'] }
  ];

  function getModelSortIndex(dataModels) {
    if (!dataModels) return MODEL_ORDER.length;
    var models = dataModels.split('|');
    var min = MODEL_ORDER.length;
    models.forEach(function (m) {
      var idx = MODEL_ORDER.indexOf(m.trim());
      if (idx !== -1 && idx < min) min = idx;
    });
    return min;
  }

  function inGroup(dataModels, groupModels) {
    var parts = (dataModels || '').split('|');
    return parts.some(function (m) { return groupModels.indexOf(m.trim()) !== -1; });
  }

  function buildModelDropdown(nativeSelect) {
    var options = Array.prototype.slice.call(nativeSelect.options);
    var selectedValue = nativeSelect.value;
    var selectedText = '';
    options.forEach(function (o) { if (o.value === selectedValue) selectedText = o.text; });

    options.sort(function (a, b) {
      return getModelSortIndex(a.dataset.models) - getModelSortIndex(b.dataset.models);
    });

    // ── Wrapper ──────────────────────────────────────────────────────────────
    var wrapper = document.createElement('div');
    wrapper.className = 'model-dd';

    // ── Trigger ──────────────────────────────────────────────────────────────
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'model-dd__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerLabel = document.createElement('span');
    triggerLabel.className = 'model-dd__label';
    triggerLabel.textContent = selectedText || t('selectModel', 'Selecteer model');

    var chevronSvg = '<svg class="model-dd__chevron" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    trigger.appendChild(triggerLabel);
    trigger.insertAdjacentHTML('beforeend', chevronSvg);

    // ── Panel ─────────────────────────────────────────────────────────────────
    var panel = document.createElement('div');
    panel.className = 'model-dd__panel';
    panel.setAttribute('role', 'listbox');
    panel.id = 'product-model-listbox';
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    trigger.setAttribute('aria-controls', panel.id);

    options.forEach(function (opt) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'model-dd__item';
      if (opt.value === selectedValue) item.classList.add('is-active');
      if (opt.disabled) { item.classList.add('is-unavailable'); item.disabled = true; }
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', opt.value === selectedValue ? 'true' : 'false');
      item.tabIndex = -1;
      item.dataset.url = opt.value;

      var soldOutLabel = t('soldOut', 'Uitverkocht');
      var nameSpan = document.createElement('span');
      nameSpan.textContent = opt.text.replace(new RegExp('\\s*—\\s*' + soldOutLabel + '$'), '');
      item.appendChild(nameSpan);

      if (opt.disabled) {
        var badge = document.createElement('span');
        badge.className = 'model-dd__oos-badge';
        badge.textContent = soldOutLabel;
        item.appendChild(badge);
      }

      item.addEventListener('click', function () {
        if (this.dataset.url) window.location.href = this.dataset.url;
      });

      panel.appendChild(item);
    });

    // ── Toggle ────────────────────────────────────────────────────────────────
    function availableItems() {
      return Array.prototype.slice.call(panel.querySelectorAll('.model-dd__item:not([disabled])'));
    }

    function focusItem(item) {
      availableItems().forEach(function (option) { option.tabIndex = option === item ? 0 : -1; });
      if (item) {
        item.focus();
        item.scrollIntoView({ block: 'nearest' });
      }
    }

    function openDD(moveFocus) {
      trigger.classList.add('is-open');
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
      var active = panel.querySelector('.model-dd__item.is-active:not([disabled])') || availableItems()[0];
      if (moveFocus) focusItem(active);
      else if (active) {
        active.tabIndex = 0;
        active.scrollIntoView({ block: 'nearest' });
      }
    }

    function closeDD() {
      trigger.classList.remove('is-open');
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      availableItems().forEach(function (option) { option.tabIndex = -1; });
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.classList.contains('is-open') ? closeDD() : openDD(false);
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        openDD(true);
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeDD();
    });

    panel.addEventListener('keydown', function (e) {
      var items = availableItems();
      var currentIndex = items.indexOf(document.activeElement);
      var nextIndex = currentIndex;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDD();
        trigger.focus();
        return;
      }
      if (e.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, items.length - 1);
      else if (e.key === 'ArrowUp') nextIndex = Math.max(currentIndex - 1, 0);
      else if (e.key === 'Home') nextIndex = 0;
      else if (e.key === 'End') nextIndex = items.length - 1;
      else return;
      e.preventDefault();
      focusItem(items[nextIndex]);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);
    nativeSelect.style.display = 'none';
    nativeSelect.parentNode.insertBefore(wrapper, nativeSelect);
  }

  var nativeModelSelect = document.getElementById('product-model-select');
  if (nativeModelSelect) buildModelDropdown(nativeModelSelect);

  // ── Upsell price update ───────────────────────────────────────────────────────
  //
  //  The main price element carries data-base-price (in cents).
  //  Every time a upsell checkbox changes we recalculate:
  //    displayed price = base price + sum of checked upsell prices
  //

  var priceCurrentEl   = document.getElementById('price-current');
  var stickyPriceEl    = document.getElementById('sticky-atc-price');
  var stickyCompareEl  = document.getElementById('sticky-atc-compare');
  var stickyBtnText    = document.getElementById('sticky-atc-btn-text');
  var totalBar         = document.getElementById('upsell-total');
  var totalCountEl     = document.getElementById('upsell-total-count');
  var totalDiscountEl  = document.getElementById('upsell-total-discount');
  var totalSumEl       = document.getElementById('upsell-total-sum');
  var upsellCheckboxes = document.querySelectorAll('.product__upsell-checkbox');

  // Recalculate prices and the dynamic upsell total bar.
  //   base       = main product's full price
  //   extra      = sum of upsell discounted prices (the customer-facing total)
  //   extraFull  = sum of upsell full prices (used to compute the savings)
  function recalcPrice() {
    if (!priceCurrentEl) return;
    var base = parseInt(priceCurrentEl.dataset.basePrice, 10) || 0;
    var extra = 0;
    var extraFull = 0;
    var selected = 0;
    upsellCheckboxes.forEach(function (cb) {
      if (cb.checked) {
        extra += parseInt(cb.dataset.price, 10) || 0;
        extraFull += parseInt(cb.dataset.basePrice, 10) || 0;
        selected += 1;
      }
    });
    var newTotal = base + extra;
    priceCurrentEl.textContent = formatMoney(newTotal);
    if (stickyPriceEl) stickyPriceEl.innerHTML = formatMoney(newTotal).replace('€ ', '€&nbsp;');

    // Dynamic upsell total bar — only shown when ≥1 upsell selected.
    if (totalBar) {
      if (selected > 0) {
        var discount = extraFull - extra; // cents saved on the upsells
        totalBar.hidden = false;
        if (totalCountEl)    totalCountEl.textContent    = selected + ' ' + (selected === 1 ? t('itemOne', 'artikel') : t('itemOther', 'artikelen'));
        if (totalDiscountEl) totalDiscountEl.innerHTML   = '−' + formatMoney(discount).replace('€ ', '€&nbsp;');
        if (totalSumEl)      totalSumEl.innerHTML        = formatMoney(newTotal).replace('€ ', '€&nbsp;');
      } else {
        totalBar.hidden = true;
      }
    }

    // ATC button text reflects total items to add (main + selected upsells).
    if (addToCartBtn) {
      var total = 1 + selected;
      var nextText = selected === 0 ? t('addToCart', 'In winkelmandje') : t('addItems', 'Voeg __N__ artikelen toe').replace('__N__', total);
      addToCartBtn._defaultText = nextText;
      // only mutate if button isn't mid-feedback ("Bezig…", "Toegevoegd ✓")
      if (!addToCartBtn._busy) addToCartBtn.textContent = nextText;
    }
    if (stickyBtnText) {
      stickyBtnText.textContent = selected === 0 ? t('addToCart', 'In winkelmandje') : t('addItems', 'Voeg __N__ artikelen toe').replace('__N__', (1 + selected));
    }
  }

  upsellCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', recalcPrice);
  });

  // ── Add to cart (AJAX) ────────────────────────────────────────────────────────
  //
  //  Each product is a single-variant SKU ("Default Title").
  //  We post the main variant plus any ticked upsell variants as
  //  separate line items via /cart/add.js items[] array.
  //

  var form         = document.getElementById('product-form');
  var variantInput = document.getElementById('variant-id');
  var addToCartBtn = document.getElementById('add-to-cart');

  if (form && addToCartBtn) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (addToCartBtn.disabled) return;

      var mainVariantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!mainVariantId) return;

      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

      // Build items array: main product first, then checked upsells. Each
      // upsell carries a hidden line item property "_upsell: 1" — the Discount
      // Function reads this marker to apply the % discount only to lines that
      // came from the carousel, not to identical products the customer added
      // separately.
      var items = [{ id: mainVariantId, quantity: qty }];

      upsellCheckboxes.forEach(function (cb) {
        if (cb.checked) {
          var vid = parseInt(cb.dataset.variantId, 10);
          if (vid) items.push({
            id: vid,
            quantity: 1,
            properties: { _upsell: '1' }
          });
        }
      });

      var originalText = addToCartBtn._defaultText || addToCartBtn.textContent;
      addToCartBtn._busy = true;
      addToCartBtn.textContent = t('busy', 'Bezig…');
      addToCartBtn.disabled = true;

      try {
        var localeRoot = (window.casifyI18n && window.casifyI18n.localeRoot) || '/';
        if (localeRoot.slice(-1) !== '/') localeRoot += '/';
        var res = await fetch(localeRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items: items }),
        });

        if (!res.ok) throw new Error('add failed');

        // Uncheck upsell boxes and reset displayed price
        upsellCheckboxes.forEach(function (cb) { cb.checked = false; });
        recalcPrice();

        // Signal other components (header cart count, drawer)
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));

        addToCartBtn.textContent = t('added', 'Toegevoegd ✓');
        setTimeout(function () {
          addToCartBtn._busy = false;
          addToCartBtn.textContent = addToCartBtn._defaultText || t('addToCart', 'In winkelmandje');
          addToCartBtn.disabled = false;
        }, 1800);

      } catch (err) {
        addToCartBtn.textContent = t('tryAgain', 'Probeer opnieuw');
        setTimeout(function () {
          addToCartBtn._busy = false;
          addToCartBtn.textContent = addToCartBtn._defaultText || originalText;
          addToCartBtn.disabled = false;
        }, 2000);
      }
    });
  }

  // ── Tabs ─────────────────────────────────────────────────────────────────────

  document.querySelectorAll('.product__tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = this.dataset.tab;

      document.querySelectorAll('.product__tab-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.product__tab-content').forEach(function (c) {
        c.classList.remove('is-active');
      });

      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');

      var content = document.querySelector('.product__tab-content[data-tab="' + tab + '"]');
      if (content) content.classList.add('is-active');
    });
  });

})();

// ── "Anderen kochten ook" slider — mirrors featured-collection pattern ──
(function () {
  'use strict';

  var track = document.getElementById('product-related-track');
  if (!track) return;

  var related = track.closest('.product__related');
  if (!related) return;

  var prevBtn = related.querySelector('.product__related-arrow--prev');
  var nextBtn = related.querySelector('.product__related-arrow--next');
  if (!prevBtn || !nextBtn) return;

  function scrollStep() {
    var card = track.querySelector('.product-card');
    if (!card) return 280;
    var gap = parseFloat(getComputedStyle(track).gap) || 16;
    return card.offsetWidth + gap;
  }

  function updateArrows() {
    var maxScroll = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 2;
    var atEnd = maxScroll <= 0 || track.scrollLeft >= maxScroll - 2;
    prevBtn.classList.toggle('is-disabled', atStart);
    nextBtn.classList.toggle('is-disabled', atEnd);
    prevBtn.setAttribute('aria-disabled', String(atStart));
    nextBtn.setAttribute('aria-disabled', String(atEnd));
  }

  prevBtn.addEventListener('click', function () {
    if (prevBtn.classList.contains('is-disabled')) return;
    track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function () {
    if (nextBtn.classList.contains('is-disabled')) return;
    track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', updateArrows, { passive: true });

  // Desktop mouse-drag
  var isDown = false, startX = 0, startScroll = 0, hasMoved = false;
  track.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    isDown = true; hasMoved = false;
    startX = e.pageX; startScroll = track.scrollLeft;
    track.classList.add('is-dragging');
  });
  track.addEventListener('mouseleave', function () {
    if (isDown) { isDown = false; track.classList.remove('is-dragging'); }
  });
  track.addEventListener('mouseup', function () {
    isDown = false; track.classList.remove('is-dragging');
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) hasMoved = true;
    track.scrollLeft = startScroll - dx;
  });
  track.addEventListener('click', function (e) {
    if (hasMoved) { e.preventDefault(); e.stopPropagation(); hasMoved = false; }
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateArrows, 100);
  }, { passive: true });

  updateArrows();
})();

// ── Sticky add-to-cart bar (mobile) ──────────────────────────────────────────
// Shows the fixed bottom bar when the main "In winkelmandje" button scrolls out
// of view, hides it when it scrolls back in. Mobile-only; the CSS is gated by
// a media query so the observer's class toggle has no effect on desktop.
(function () {
  var mainBtn = document.getElementById('add-to-cart');
  var stickyBar = document.getElementById('product-sticky-atc');
  if (!mainBtn || !stickyBar || typeof IntersectionObserver === 'undefined') return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // Only show sticky bar when the main button has scrolled OFF the TOP
      // (user has scrolled past it). Don't show when the main button is still
      // below the viewport — the user hasn't reached it yet.
      var pastTheTop = entry.boundingClientRect.bottom < 0;
      var shouldShow = !entry.isIntersecting && pastTheTop;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -10px 0px'
  });

  io.observe(mainBtn);
})();
